import { useApi } from '@/api'

export const useBrandFontsResource = () => {
  const api = useApi()
  const brandOf = (organizationId: string, brandId: string) => api.api.v1.organizations({ organizationId }).brands({ brandId })

  return {
    setBrandFonts: (organizationId: string, brandId: string, body: Parameters<ReturnType<typeof brandOf>['fonts']['put']>[0]) =>
      brandOf(organizationId, brandId).fonts.put(body),
    setBrandFont: (organizationId: string, brandId: string, body: Parameters<ReturnType<typeof brandOf>['fonts']['post']>[0]) =>
      brandOf(organizationId, brandId).fonts.post(body),
    importBrandFont: (
      organizationId: string,
      brandId: string,
      body: Parameters<ReturnType<typeof brandOf>['fonts']['import']['post']>[0]
    ) => brandOf(organizationId, brandId).fonts.import.post(body),
    delBrandFont: (organizationId: string, brandId: string, fontId: string) => brandOf(organizationId, brandId).fonts({ fontId }).delete()
  }
}
